export const TRACK_TYPES = {
  TRACK_EVENT: 'trackEvent',
  TRACK_PAGE_VIEW: 'trackPageView',
};

export const MATOMO_CONFIG = {
  SUBSCRIPTION: 'cds',
  CONTAINER_ID: 'nReWEhTy',
};
